import logic from "src/utils/genLogic";
import { ActionTypes } from "./actions";
import { push } from "connected-react-router";
import { Trans } from "@lingui/react";

const apiNamespace = "settings";

const getSettingsLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_SETTINGS,
});

const getSettingWithId = logic(apiNamespace, {
  actionName: ActionTypes.GET_SETTING_WITH_ID,
});

const editSettingLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_SETTING,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_edited_successfully" />,
});

const editAllSettingsLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_ALL_SETTINGS,
  successCb: (dispatch) => {
    dispatch(push("/home/setting"));
  },
});

export default [
  getSettingsLogic,
  getSettingWithId,
  editSettingLogic,
  editAllSettingsLogic,
];
